import Amplify from "aws-amplify";
import AWS_CONFIG from "../../constants/aws.constants";

export const setupAmplify = () => {
  Amplify.configure(AWS_CONFIG);
};
